import AbortService from "@rmp/core/services/abortService";
import BaseOrganizationController from "@rmp/core/api/base/baseOrganizationController";
import {
	ApiMasterAccountMasterApplicationLegalEntityCreateDto,
	ApiMasterAccountMasterApplicationEntrepreneurCreateDto,
	ApiMasterAccountMasterApplicationLegalEntityByEmployeeDto,
	ApiMasterAccountMasterApplicationEntrepreneurByEmployeeDto
} from "@rmp/api-gateway";
import { getCaptchaRequestParams } from "@rmp/core/services/captcha";

export class MasterAccountAccessApplicationController extends BaseOrganizationController {
	constructor(abortService: AbortService) {
		super(abortService);
	}
	
	getMasterAccountAccessApplications = this.api.masterApplication.masterApplicationListByIds;
	
	approveMasterAccountAccessApplication = this.api.masterApplication.approveUpdateById;
	
	declineMasterAccountAccessApplication = this.api.masterApplication.rejectUpdateById;
	
	submitLegalEntityMasterAccountAccessApplication = (payload: ApiMasterAccountMasterApplicationLegalEntityCreateDto,
		captchaToken: string) =>
		this.api.masterApplication.legalEntityCreate(payload, getCaptchaRequestParams(captchaToken));
	
	submitLegalPersonMasterAccountAccessApplication = (payload: ApiMasterAccountMasterApplicationEntrepreneurCreateDto,
		captchaToken: string) =>
		this.api.masterApplication.entrepreneurCreate(payload, getCaptchaRequestParams(captchaToken));
	
	submitSignedLegalEntityAccessApplication = this.api.masterApplication.legalEntityEdsCreate;
	
	submitSignedLegalPersonAccessApplication = this.api.masterApplication.entrepreneurEdsCreate;
	
	submitLegalEntityAccessFromEmployeeApplication = (payload: ApiMasterAccountMasterApplicationLegalEntityByEmployeeDto,
		captchaToken: string) =>
		this.api.masterApplication.legalEntityEmployeeCreate(payload, getCaptchaRequestParams(captchaToken));
	
	submitLegalPersonAccessFromEmployeeApplication = (payload: ApiMasterAccountMasterApplicationEntrepreneurByEmployeeDto,
		captchaToken: string) =>
		this.api.masterApplication.entrepreneurEmployeeCreate(payload, getCaptchaRequestParams(captchaToken));
	
	getLegalEntityAccountApplicationId = this.api.masterApplication.legalEntityExistsListByInn;
	
	getLegalPersonAccountApplicationId = this.api.masterApplication.entrepreneurExistsListByInn;
	
	getMasterAccountAccessApplication = this.api.masterApplication.masterApplicationDetailById;
}
